module.exports = __webpack_public_path__ + "img/first_bg03.bf4e948d.png";